import React from 'react';
import { useEffect, useContext } from 'react';
import AppContext from '../../components/context/AppContext';
import axios from 'axios';
import Contact from '../../components/sectionContact';
import Footer from '../../components/sectionFooter';
import SectionBLogArticle from '../../components/sectionBLogArticle';
import Head from 'next/head';
import NavBlog from '../../components/sectionBLogArticle/navBlog';

function AticleUrl({ article, similarArticles, err, mostViewArticles, errMost }) {
 const { setLangContext } = useContext(AppContext);

 useEffect(() => {
  setLangContext('fr');
 });

 return (
  <div className='flex  flex-col  '>
   <Head>
    <title> {!err && article && article.articleData && article.length != 0 ? article.articleData[0].title : 'JAMIVIZ - Développeur Web 3D à Montreal'}</title>

    <meta property='og:title' content={`${!err && article && article.articleData && article.length != 0 ? article.articleData[0].title : 'JAMIVIZ - Développeur Web 3D à Montreal'}`} />
    <link rel='alternate' href={`https://jamiviz.com/articles/${article && article.articleData && article.length != 0 ? article.articleData[0].articleUrl : 'empty'}`} hrefLang='fr' />
   </Head>
   <NavBlog />

   <SectionBLogArticle mostViewArticles={mostViewArticles} errMost={errMost} article={article} similarArticles={similarArticles} err={err} />
   <Contact />
   <Footer />
  </div>
 );
}

export default AticleUrl;

//prettier-ignore
export const getServerSideProps = async ({ query, params }) => {
  let article = [];
  let similarArticles = [];
  let mostViewArticles =[];
  let errMost = ""

  const apiClient = axios.create({
    headers: {
      'Cache-Control': 'no-store'
    }
  });


  try {

    try {
      article = await apiClient.get(`${process.env.NEXT_PUBLIC_origin}/api/article/${params.articleUrl[0]}`);
      article = article.data;
    } catch (error) {
      article = [];
    }

    try {
      similarArticles = await apiClient.get(`${process.env.NEXT_PUBLIC_origin}/api/articles/similarArticles`);
      similarArticles = similarArticles.data;
    } catch (error) {
      similarArticles = [];
    }

    try {
      
      mostViewArticles = await apiClient.get(`${process.env.NEXT_PUBLIC_origin}/api/articles/mostViewArticles`);
      mostViewArticles = mostViewArticles.data;
      errMost ="";
    } catch (error) {
      console.log(error)
      errMost ="rejected";
      mostViewArticles = [];
    }

    



      //throw new Error();

    return {
      props: {article,mostViewArticles, similarArticles,err: "" , errMost :""},
    };
  } catch (err) {
    return { props: { mostViewArticles: mostViewArticles.data ? mostViewArticles.data : [], article: [], similarArticles: [], err: "rejected" ,errMost } };
  }
};
